export const content = {
  header: {
    tagline: "Where Urban Luxury Meets Artisan Taste.",
    navigation: [
      { label: "Home", href: "#hero" },
      { label: "About", href: "#hotel-info" },
      { label: "Menu", href: "https://drive.google.com/file/d/1K2k1iDkkdEFgN0rQO80NhopdLpPmetx6/view", external: true },
      { label: "Photos", href: "#photos" },
      { label: "Contact", href: "#contact" }
    ]
  },
  hero: {
    headline: "Downtown Restaurant and Lounge Sheraton Khalidiya",
    subHeadline: "A contemporary retreat on the Ground Floor. Experience a fusion of international and local cuisines in a sophisticated, modern setting."
  },
  hotelInfo: {
    title: "Downtown Restaurant and Lounge Sheraton Khalidiya",
    description: "Located in the heart of Abu Dhabi at the Sheraton Khalidiya Hotel, Downtown Restaurant and Lounge is your perfect spot for a romantic evening or a casual business meeting. Open daily from 8 AM to 2 AM, we serve everything from signature sushi and grilled meats to artisan pastries and specialty coffees. Enjoy our wireless internet and warm, welcoming service."
  },
  menuExperience: {
    signatureBlends: "Masterfully roasted beans sourced from the world's finest estates, brewed to perfection.",
    chefsSpecials: "Culinary innovations that fuse local flavors with international techniques.",
    artisanPastries: "Hand-crafted daily by our resident patissier, pairing perfectly with our specialty coffees."
  },
  footer: {
    address: "Sheraton Khalidiya Hotel Ground floor - Al Hisn - W7 01 - Abu Dhabi - United Arab Emirates",
    plusCode: "Plus Code: F8FX+XQ Abu Dhabi - United Arab Emirates",
    phone: "+971 2 692 8500",
    whatsapp: "+971 2 692 8500",
    instagram: "www.instagram.com/downtown.sheraton",
    hours: "Open daily 8:00 AM - 2:00 AM",
  },
  menuItems: {
  }
};
